export default __webpack_public_path__ + "static/media/clinicleanv.967cbcb3.png";